(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    if (root.dataset.abmRvReady) return;
    root.dataset.abmRvReady = 'true';
    const slides = [...root.querySelectorAll('.abm-rv__slide')];
    const dots = [...root.querySelectorAll('[data-abm-rv-dot]')];
    const current = root.querySelector('[data-abm-rv-current]');
    const viewport = root.querySelector('[data-abm-rv-viewport]');
    if (slides.length < 2) return;

    let index = 0;
    let hovering = false;
    let visible = false;

    const sync = () => {
      const run = !reduce.matches && visible && !document.hidden;
      root.classList.toggle('is-running', run);
      root.classList.toggle('is-paused', run && hovering);
    };

    const go = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.classList.toggle('is-done', i < index);
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (current) current.textContent = String(index + 1).padStart(2, '0');
    };

    root.addEventListener('animationend', (event) => {
      if (event.animationName === 'abm-rv-fill') go(index + 1);
    });
    dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));
    root.querySelector('[data-abm-rv-prev]')?.addEventListener('click', () => go(index - 1));
    root.querySelector('[data-abm-rv-next]')?.addEventListener('click', () => go(index + 1));

    root.addEventListener('pointerenter', (event) => { if (event.pointerType === 'mouse') { hovering = true; sync(); } });
    root.addEventListener('pointerleave', () => { hovering = false; sync(); });
    root.addEventListener('focusin', () => { hovering = true; sync(); });
    root.addEventListener('focusout', (event) => { if (!root.contains(event.relatedTarget)) { hovering = false; sync(); } });

    viewport.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') go(index + 1);
      if (event.key === 'ArrowLeft') go(index - 1);
    });

    let startX = null;
    viewport.addEventListener('pointerdown', (event) => { startX = event.clientX; });
    viewport.addEventListener('pointerup', (event) => {
      if (startX === null) return;
      const delta = event.clientX - startX;
      startX = null;
      if (Math.abs(delta) > 40) go(index + (delta < 0 ? 1 : -1));
    });

    new IntersectionObserver((entries) => {
      visible = entries[0].isIntersecting;
      sync();
    }, { threshold: 0.35 }).observe(root);
    document.addEventListener('visibilitychange', sync);
    reduce.addEventListener?.('change', sync);
  }

  const boot = (scope) => scope.querySelectorAll('[data-abm-reviews]').forEach(init);
  boot(document);
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const root = event.target.closest('[data-abm-reviews]');
    if (!root) return;
    const slides = [...root.querySelectorAll('.abm-rv__slide')];
    const dot = root.querySelectorAll('[data-abm-rv-dot]')[slides.indexOf(event.target)];
    dot && dot.click();
  });
})();
